'use strict';

var Textfield = require('./Textfield');

/**
 * Functions well in Chrome, Safari, Firefox, and Internet Explorer.
 * @constructor
 * @extends Textfield
 */
var Number = Textfield.extend('Number', {

    initialize: function(grid, cellEvent) {
        if (cellEvent.properties.localizer) {
            this.localizer = cellEvent.properties.localizer;
            this.localizer.format = function(v) { return v; };
        } else {
            this.localizer = grid.localization.get('number');
        }
    }

});

module.exports = Number;
